import React from 'react';
import ReactDOM from 'react-dom/client';
import { ModalStackProvider } from '@agendor/ui';
import App from './App';
import { capturePendingConnectorCode } from './whatsapp-connector';

const whatsappAppIdKey = 'REACT_APP_WHATSAPP_APP_ID';
if (!process.env[whatsappAppIdKey]) {
    throw new Error(`No value found for environment value "${whatsappAppIdKey}"`);
}

const whatsappOnboardingConfigIdKey = 'REACT_APP_WHATSAPP_ONBOARDING_CONFIG_ID';
const whatsappOnboardingConfigId = process.env[whatsappOnboardingConfigIdKey];
if (!whatsappOnboardingConfigId) {
    throw new Error(`No value found for environment value "${whatsappOnboardingConfigIdKey}"`);
}

const connectorDownloadUrlKey = 'REACT_APP_CONNECTOR_DOWNLOAD_URL';
if (!process.env[connectorDownloadUrlKey]) {
    throw new Error(`No value found for environment value "${connectorDownloadUrlKey}"`);
}

capturePendingConnectorCode(window.location);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <ModalStackProvider>
            <App whatsappOnboardingConfigId={whatsappOnboardingConfigId} />
        </ModalStackProvider>
    </React.StrictMode>,
);
